import { render, staticRenderFns } from "./PropertyNumber.vue?vue&type=template&id=279b4342&"
import script from "./PropertyNumber.vue?vue&type=script&lang=js&"
export * from "./PropertyNumber.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports